import Vue from 'vue'

import config from './config'
import router from '../router'

const ROLES = [
  { level: 'guest', label: '손님' },
  { level: 'user1', label: '사용자' },
  { level: 'user2', label: '사용자' },
  { level: 'user3', label: '사용자' },
  { level: 'user4', label: '사용자' },
  { level: 'user5', label: '사용자' },
  { level: 'master1', label: '관리자' },
  { level: 'master2', label: '관리자' },
  { level: 'master3', label: '관리자' },
  { level: 'master4', label: '관리자' },
  { level: 'master5', label: '수퍼관리자' },
  { level: 'head-master', label: '비밀관리자' },
  { level: 'system1', label: '시스템관리자' },
  { level: 'system2', label: '시스템관리자' },
  { level: 'system3', label: '시스템관리자' },
  { level: 'head-system', label: '비밀시스템관리자' }
]

const getLevel = role => {
  const idx = ROLES.findIndex(ROLE => ROLE.level === role)
  return idx > 0 ? idx : 0
}
const getLabel = role => {
  const idx = getLevel(role)
  return ROLES[idx].label
}

export default {
  getLevel,
  getLabel,
  route: {
    query ({ key, defalutValue } = { defaultValue: '' }) {
      const { query } = router.currentRoute
      return query[key] || defalutValue
    }
  },
  router: {
    repush ({ query, replace } = { replace: false }) {
      const currentQuery = replace ? {} : router.currentRoute.query
      router.push({
        path: router.currentRoute.path,
        query: {
          ...currentQuery,
          ...query
        }
      })
    }
  },
  params (arg) {
    const { query } = router.currentRoute

    if (arg === 'page') {
      const page = Number.parseInt(query.page, 10) || 1
      return {
        page: page - 1,
        limit: config.page.limit
      }
    } else if (arg === 'order') {
      const order = query.order || ''
      const orderAsc = query.orderAsc === 'true' ? 'true' : 'false'

      if (order) {
        return {
          order,
          orderAsc
        }
      }
    } else {
      const { query } = router.currentRoute
      const value = query[arg]
      if (value) {
        return {
          [arg]: value
        }
      }
    }
    return {}
  },
  diff: function (source, target) {
    //   let res = {}
    //   for (let key in source) {
    //     if (source[key] !== target[key]) {
    //       res[key] = source[key]
    //     }
    //   }
    //   return res
    // },
    // diffAsJSON: function (source, target) {
    let res = {}
    for (let key in source) {
      if (JSON.stringify(source[key]) !== JSON.stringify(target[key])) {
        res[key] = source[key]
      }
    }
    return res
  },
  download ({ url, query, filename }) {
    Vue.prototype.$http
      .get(`${url}`, { params: query, responseType: 'blob' })
      .then(response => {
        // const url = window.URL.createObjectURL(new Blob([response.data]))
        // const link = document.createElement('a')
        // link.href = url
        // link.setAttribute('download', this.filename)
        // document.body.appendChild(link)
        // link.click()

        // It is necessary to create a new blob object with mime-type explicitly set
        // otherwise only Chrome works like it should
        var newBlob = new Blob([response.data])
        // IE doesn't allow using a blob object directly as link href
        // instead it is necessary to use msSaveOrOpenBlob
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(newBlob, filename)
          return
        }
        // For other browsers:
        // Create a link pointing to the ObjectURL containing the blob.
        const data = window.URL.createObjectURL(newBlob)
        var link = document.createElement('a')
        link.href = data
        link.download = filename
        link.click()
        setTimeout(function () {
          // For Firefox it is necessary to delay revoking the ObjectURL
          window.URL.revokeObjectURL(data)
        }, 100)
      })
      .catch(err => {
        console.log(err)
      })
  }
}
